import React from 'react';

function RelatedLinks(props) {
  const items = Array.isArray(props.items) ? props.items : [];

  const links = items
    .filter(item => item && item.url && item.title)
    .map((item, index) => (
      <li key={item.url || index}>
        <a
          className="shrink-0 whitespace-nowrap bg-[#F3F3F3] px-6 py-4 h-[54px] flex items-center text-[16px] font-medium leading-none text-black transition-colors duration-200 hover:bg-[#e5e5e5] phone:h-[49px] phone:text-[14px]"
          href={item.url}>
          {item.title}
        </a>
      </li>
    ));

  return (
    <section className="section related-links-section pb-[45px]">
      <div className="container">
        <div className="text-[16px] leading-[24px] font-medium text-grey-90 desktop:text-[24px] desktop:leading-[36px]">{props.title}</div>
        <ul className="flex gap-3 items-center pt-6 w-full overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] list-none p-0 m-0 phone:pt-[16px]">
          {links}
        </ul>
      </div>
    </section>
  )
}

export default RelatedLinks;
